import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import PermissionCheck from "../../../Component/PermissionCheck";
import {
  useDeleteIVFJourneyMutation,
  useUpdateIVFJourneyMutation,
  useUpdateIVFJourneystepMutation,
} from "../../../Service/ivfJourneyStage";
import { FaBullseye } from "react-icons/fa";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";

import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import EnhancedSubTableHead from "./SubTableHead";

const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  state: any;
  setstates: any;
  setJourney: any;
  refetch: any;
  setUpdated: any;
  updated: any;
  journeys: any;
  deleted: any;
  setDeleted: any;
  openSnackBar: any;
}
function TableList({
  getComparator,
  order,
  updated,
  orderBy,
  handleClick,
  handleChange,
  state,
  setstates,
  openSnackBar,
  deleted,
  setDeleted,
  setJourney,
  setUpdated,
  journeys,
  refetch,

  stableSort,
}: props) {
  const classes = useStyles();
  const [ishover, sethover] = useState(null);
  const handleMouseEnter = (index) => {
    sethover(index);
  };
  // console.log("journeys",journeys);

  const dispatch = useDispatch<any>();
  const [deleteJourney] = useDeleteIVFJourneyMutation();

  const DashboardStatus = [
    {
      id: 1,
      name: "Active",
      descriptions: "Active",
      others: "#ff0000",
      mode: "journey_status",
      status: "1",
      comments: null,
      createdBy: null,
      updatedBy: null,
      createdAt: "2024-02-06T11:57:40.000Z",
      updatedAt: "2024-02-06T11:57:40.000Z",
    },
    {
      id: 2,
      name: "Inactive",
      descriptions: "Inactive",
      others: "#00ff27",
      mode: "journey_status",
      status: "0",
      comments: null,
      createdBy: null,
      updatedBy: null,
      createdAt: "2024-02-06T11:57:40.000Z",
      updatedAt: "2024-02-06T11:57:40.000Z",
    },
  ];
  const [updateJourney] = useUpdateIVFJourneyMutation();
  const [updateJourneystep] = useUpdateIVFJourneystepMutation();

  // console.log(DashboardStatus);

  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.status,
  }));
  // console.log(status);

  const handleMouseLeave = () => {
    sethover(null);
  };

  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();
  const Delete = async (bool) => {
    if (bool) {
      try {
        await deleteJourney(deleteId).unwrap();
        openSnackBar("Deleted successfully");
        setDeleted(true);
      } catch (err: any) {
        // console.log("err",err);

        openSnackBar(err.data.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this User?", false, null);
  };
  const getValueByStatus = (status) => {
    // Check if status is an array before calling the find method
    if (Array.isArray(status)) {
      let val = status.find((item) => item.status === status);
      if (val) {
        return val.name;
      }
    }
    // Return a default value if status is not an array or if no matching item is found
    return 1;
  };

  const [openSubLevels, setOpenSubLevels] = useState({});

  const handleToggleSubLevel = (headerIndex) => {
    // console.log("test");

    setOpenSubLevels((prevState) => ({
      ...prevState,
      [headerIndex]: !prevState[headerIndex],
    }));
  };

  // console.log(getValueByStatus(1));

  const formatDateAndTime = (dateString: string) => {
    const date = new Date(dateString);

    // Format date
    const optionsDate: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "long",
      year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    // Format time
    const optionsTime: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    // Convert month name to uppercase
    const parts = formattedDate.split(" ");
    parts[1] = parts[1].slice(0, -1);

    // console.log(parts[1]);

    parts[0] = parts[0].toUpperCase();
    parts[0] = parts[0].slice(0, 3);

    // console.log(parts[0]);

    // console.log(`${parts[0]} ${parts[1]} ${parts[2]} ${formattedTime}`);

    // Return formatted date and time
    return (
      <>
        {parts[1]} {parts[0]} {parts[2]}
        <br />
        {formattedTime}
      </>
    );
  };

  const inputDate = "30 January 2024, 5:57 pm";
  const formattedDateTime = formatDateAndTime(inputDate);
  // console.log(formattedDateTime);

  const handleSelectChange = (event, stage) => {
    const { name, value } = event.target;
    if (stage.id) {
      var { activeStatus, steps } = stage;
      // console.log(activeStatus);
      // console.log(value);
      activeStatus = value;

      const extractedData = { steps, activeStatus };

      updateJourney({
        id: stage.id,
        ...extractedData,
      });
      setUpdated(true);
      refetch();
      setTimeout(() => {
        setUpdated(FaBullseye);
      }, 1000);
    }
  };
  const handleSelectChangeStep = (event, step) => {
    const { name, value } = event.target;
    if (step.id) {
      var { activeStatus, id } = step;
      // console.log(activeStatus);
      // console.log(value);
      // console.log(id);

      activeStatus = value;

      const extractedData = { activeStatus };

      updateJourneystep({
        id: step.id,
        ...extractedData,
      });
      setUpdated(true);
      refetch();
      setTimeout(() => {
        setUpdated(FaBullseye);
      }, 1000);
    }
  };

  const onClick = (journey) => {
    // console.log(journey);

    setJourney(journey);
    setUpdated(false);

    setstates(!state);
  };

  return (
    <>
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {stableSort(journeys, getComparator(order, orderBy))?.map((a, i) => {
        return (
          <>
            <TableRow
              className="header-level"
              role="checkbox"
              tabIndex={-1}
              key={i}
              onClick={() => handleToggleSubLevel(i)}
            >
              <TableCell align="left">{a.journeyStageName}</TableCell>
              <TableCell align="left">{a.description}</TableCell>

              <TableCell align="left">
                {formatDateAndTime(a.updatedAt)}
              </TableCell>

              <TableCell align="left">
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                  <SelectMenuItem
                    styles={
                      a.activeStatus === 1
                        ? "select select-option-active"
                        : "select select-option-inactive"
                    }
                    name="status"
                    option={status}
                    view={false}
                    value={a.activeStatus}
                    onChange={(e) => handleSelectChange(e, a)}
                  />
                </FormControl>
              </TableCell>
              {/* <TableCell align="left">
              <span>{a.last_contacted}</span>
              <br></br>
              <small>{a.time}</small>
            </TableCell> */}
              <TableCell align="left">
                  <img
                    src={edit}
                    alt="edit"
                    className="blue-c action-icon cursur"
                    onClick={() => onClick(a)}
                  />
                &nbsp;&nbsp;&nbsp;
                {/* {PermissionCheck("ivf_journey_stages", "delete") && (
                <img
                  src={dele}
                  alt="delete"
                  onClick={() =>
                    openDelete(
                      "Are you sure you want to delete this journey stage?",
                      true,
                      a.id
                    )
                  }
                  className="delete-icon cursur action-icon"
                />
              )} */}
              </TableCell>
            </TableRow>
            {openSubLevels[i] && (
              <>
                <TableRow
                  className="sub-level"
                  role="checkbox"
                  tabIndex={-1}
                  key={i}
                >
                  <TableCell className="table-head" align="left">
                    Step Name
                  </TableCell>
                  <TableCell className="table-head" align="left">
                    Description
                  </TableCell>

                  <TableCell className="table-head" align="left">
                    Last edited date
                  </TableCell>

                  <TableCell className="table-head" align="left">
                    Status
                  </TableCell>
                  {/* <TableCell align="left">
             <span>{a.last_contacted}</span>
             <br></br>
             <small>{a.time}</small>
           </TableCell> */}
                  <TableCell className="table-head" align="left">
                    Action
                  </TableCell>
                </TableRow>
                {a.steps.map((step) => (
                  <TableRow
                    className="sub-level"
                    role="checkbox"
                    tabIndex={-1}
                    key={step.id}
                  >
                    <TableCell align="left">{step.stepName}</TableCell>
                    <TableCell align="left">{step.description}</TableCell>

                    <TableCell align="left">
                      {formatDateAndTime(step.updatedAt)}
                    </TableCell>

                    <TableCell align="left">
                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <SelectMenuItem
                          styles={
                            step.activeStatus === 1
                              ? "select select-option-active"
                              : "select select-option-inactive"
                          }
                          name="status"
                          option={status}
                          view={false}
                          value={step.activeStatus}
                          onChange={(e) => handleSelectChangeStep(e, step)}
                        />
                      </FormControl>
                    </TableCell>
                    {/* <TableCell align="left">
             <span>{a.last_contacted}</span>
             <br></br>
             <small>{a.time}</small>
           </TableCell> */}
                    <TableCell align="left">
                      <img
                        src={edit}
                        alt="edit"
                        className="blue-c action-icon cursur me-2"
                        onClick={() => onClick(a)}
                      />
                      <img
                        src={dele}
                        alt="delete"
                        onClick={() =>
                          openDelete(
                            "Are you sure you want to delete this journey stage?",
                            true,
                            a.id
                          )
                        }
                        className="delete-icon cursur action-icon"
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </>
            )}
          </>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
